<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcPaymentForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
